import { Avatar, IconStatus, TableBody, TableItem, HStack, VStack } from '@genial/components';
import { Color, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box, Text } from 'native-base';
import React from 'react';

import { SentOrderDetailResponseNormalized } from '../../../../../store/rateManagement/selector';

import { CardItemError } from './CardItemError';

export declare namespace TableCustomerDetailItemTypes {
  export interface Props {
    item: Utils.ArrayElement<SentOrderDetailResponseNormalized['invalidCustomers']>;
    isLoading?: boolean;
  }
}

export const TableCustomerDetailErrorItem: React.FC<TableCustomerDetailItemTypes.Props> = ({
  item,
  isLoading,
}) => {
  const getStatusIcon = () => {
    if (
      item.customerIconNormalized &&
      item.customerIconColorNormalized &&
      item.customerIconSizeNormalized &&
      item.customerIconBackgroundNormalized
    ) {
      return (
        <IconStatus
          icon={item.customerIconNormalized}
          color={item.customerIconColorNormalized as ColorTypes.Option}
          testId="header-section-status-icon"
          size={item.customerIconSizeNormalized}
          bgColor={item.customerIconBackgroundNormalized}
        />
      );
    }
  };

  const currentStatus = getStatusIcon();

  const responsiveItem = useBreakpointValue({
    base: <CardItemError currentStatus={currentStatus} isLoading={isLoading} item={item} />,
    sm: (
      <TableBody testId="table-body">
        <TableItem width={40} align="start" testId="header-clients">
          <HStack width="100%" alignItems="center" flex={1}>
            <Box alignItems="center" mr={Spacing['inset.xs']}>
              {currentStatus}
            </Box>

            <Box alignItems="center" mr={Spacing['inset.xs']}>
              <Avatar
                testId="table-customer-suitability"
                bgColor={'linechart.principal'}
                initials={item.customerNameNormalized}
                textColor={'neutral.white'}
              />
            </Box>

            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              fontWeight={Typography['fontweight.semibold']}
              flex={1}
              textAlign="start">
              {item.customerNameNormalized}
            </Text>
          </HStack>
        </TableItem>

        <TableItem width={60} align="start" testId="header-clients">
          <VStack width="100%" py={Spacing['inset.xs']} justifyContent="space-between" flex={1}>
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              paddingBottom={Spacing['inset.nano']}
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              fontWeight={Typography['fontweight.semibold']}
              flex={1}
              textAlign="start">
              Descrição
            </Text>
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              fontWeight={Typography['fontweight.regular']}
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              color={Color['neutral.medium']}
              flex={1}
              textAlign="start">
              {item.processErrorDescription?.map((error, index) => (
                <Text key={index.toString()} mr={Spacing['inset.nano']}>
                  {error.errorMessageAlias}
                </Text>
              ))}
            </Text>
          </VStack>
        </TableItem>
      </TableBody>
    ),
  });

  return <Box flex={1}>{responsiveItem}</Box>;
};
